import { ForwardedRef, useImperativeHandle, forwardRef } from 'react';
import { useGlobal } from '@/utils/useGlobal';
//import { EFEmail } from '@/components/UI/svg/Footer';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';
import klaviyoCss from '@/components/SignUpForm/Klaviyo/index.module.scss';

interface IKlaviyoViewProps {
    id?: string;
    list_id: string;
    submitText: string;
    placeholder?: string;
    disabled?: boolean;
    cancelContent?: any;
}

export type IKlaviyoViewHandle = {
    clearInputValue: () => void;
};

const KlaviyoView = ({ id, list_id, submitText, placeholder, disabled, cancelContent }: IKlaviyoViewProps, ref: ForwardedRef<IKlaviyoViewHandle>) => {
    const { useLang, useState } = useGlobal();
    const { t } = useLang('shared');
    const [inputValue, setInputValue] = useState('');
    const onInput = (e: any) => {
        setInputValue(e?.target.value.trim());
    };

    useImperativeHandle(ref, () => ({
        clearInputValue: () => setInputValue(''),
    }));

    const calDisable = () => {
        const reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,10}$/;
        return !reg.test(inputValue);
    };

    const handleCancel = () => {
        cancelContent?.callback && cancelContent?.callback();
    };

    return (
        <form
            id={id || 'email_signup'}
            className={klaviyoCss.klaviyo_form}
            action="https://manage.kmail-lists.com/subscriptions/subscribe"
            data-ajax-submit="https://manage.kmail-lists.com/ajax/subscriptions/subscribe"
            method="GET"
            target="_blank"
            noValidate
        >
            <input type="hidden" name="g" value={list_id} />
            <div className="main">
                <div className="klaviyo_field_group">
                    <span className="email-icon">
                        <EFEmail />
                    </span>
                    <input
                        type="email"
                        name="email"
                        id="k_id_email"
                        value={inputValue}
                        onInput={onInput}
                        placeholder={placeholder ?? t('common.email_holder')}
                    />
                </div>
                <div className="klaviyo_form_actions">
                    <button type="submit" disabled={calDisable() || disabled} className="klaviyo_submit_button">
                        {submitText}
                    </button>
                </div>
            </div>
            {!!cancelContent && (
                <div className="cancel-box" onClick={handleCancel}>
                    <p className="cancel-text">{cancelContent?.text}</p>
                </div>
            )}

            <div className="klaviyo_messages">
                <div className="success_message" style={{ display: 'none' }}></div>
                <div className="error_message" style={{ display: 'none' }}></div>
            </div>
        </form>
    );
};

export default forwardRef<IKlaviyoViewHandle, IKlaviyoViewProps>(KlaviyoView);
